import React from 'react'
import KmlMap from './KmlMap'
import './shared.css'
import mapService from '../../services/shared.map.service'
import PublicLayout from '../../layout/PublicLayout'
import SharedLoginModal from "../../commons/SharedLoginModal";

class SharedMapsView extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            urlKml: null,
            error: null,
            token: null,
            showLoginModal: true,
        }
    }

    componentDidMount() {
        console.log("location:", this.props.location.pathname);
        const pathname = this.props.location.pathname;
        const idx = pathname.lastIndexOf('/');
        const token = pathname.substr(idx + 1);
        console.log("token:", token);
        this.setState({
            token: token
        });
       this.loadUrlKml(token)
    }

    loadUrlKml= (token, jwt)=>{
        mapService.getUrlKml(token, jwt).then(urlKml => {
            console.log("urlKml:", urlKml)
            this.setState({urlKml: urlKml});
        }).catch( error => {
            this.setState({error: error})
        })
    }

    login = (username, password) => {
        mapService.login(username, password)
            .then( rsp => {
                console.log('login rsp:', rsp)
                this.setState({showLoginModal: false, error: null})
                this.loadUrlKml(this.state.token, rsp.jwt)
            })
            .catch(err =>{
                this.setState({error: err, showLoginModal: false})
            })
    }

    render() {
        if ( this.state.error && this.state.error.message === "401"){
            return (
                <PublicLayout>
                    <SharedLoginModal visible={this.state.showLoginModal} onSubmit={this.login} onCancel={() => {
                        this.setState({showLoginModal: false})
                    }}/>
                </PublicLayout>
            )
        }
        return (
            <PublicLayout>
                { this.state.urlKml && (<KmlMap urlKml={this.state.urlKml}/>) }
            </PublicLayout>
        )
    }
}

export default SharedMapsView;
